module.exports = __webpack_public_path__ + "static/media/39.ba31722a.png";